import { AuthFetchWithResult } from '@e3dc-react/shell/Types/api'
import { ChargingSessionModelV1 } from '../models/charging-session.model'
import { toChargingSessions } from '../transformers/to-charging-sessions'
import { ChargingSessionResponseDto } from './dto/charging-session-response.dto'
import { WallboxHardwareModel } from 'src/Libs/wallboxes/models'
import { EMobilityWallboxPricesModel } from 'src/Libs/e-mobility/emobility-wallbox/models/e-mobility-wallbox-models'

export const fetchChargingSessions = (
  storageId: string,
  chargePrices: (EMobilityWallboxPricesModel[] | undefined)[],
  dischargePrices: (EMobilityWallboxPricesModel[] | undefined)[],
  wallboxes: WallboxHardwareModel[],
  authFetch: AuthFetchWithResult
): Promise<ChargingSessionModelV1[]> => {
  return authFetch<ChargingSessionResponseDto>({
    path: `e-mobility/${storageId}/charging`,
    endpoint: process.env.REACT_APP_EMOBILITY_ENDPOINT,
    payload: {
      /**
       * We are fetching all sessions at once to fill the chart with the full charging history. Also, this eases the advances sorting and filtering
       * logic in the charging session table.
       *
       * However, there is a limit on backend side: we can only fetch a maximum of 10 000 sessions in a single request. This means any installation
       * with more than 10 000 sessions will return only the earliest 10 000 sessions and the newest ones being cut out from the response, therefore
       * never shown in the table.
       *
       * As a workaround, we fetch all sessions sorted by their creation date, BUT in reverse order. This will still keep the total session count at
       * 10 0000, but the earliest sessions will be cut out instead of the new ones, which is a lesser issue.
       */
      sort: '-createdAt',
    },
  }).then(response => {
    return toChargingSessions(response, chargePrices, dischargePrices, wallboxes)
  })
}
